import DashboardHeader from '../DashboardHeader';
import Charts from './charts';
import InwardStatusBarChart from './InwardStatusBarChart';
import DatewiseTable from './DatewiseTable';  
import { useEffect, useState } from 'react';
import moment from 'moment';
import DashboardDataService from '../../../services/dashboard.service';
import MonthWiseShipmentTable from './MonthWiseShipment';
import Logvsentry from './logvsentry';


const InwardDashboard = () => {

  const [selectedMonth, setSelectedMonth] = useState(moment().format('MM'));
  const [selectedYear, setSelectedYear] = useState(moment().format('YYYY'));

  const [lastDate, setLastDate] = useState(31);
  const  todaysDate = moment().format('DD/MM/YYYY');
  const [dateWiseData, setdateWiseData] = useState([]);
  const [dataforBarChart, setdataforBarChart] = useState([]);
  const [inwardShipmentofMonth, setInwardShipmentofMonth] = useState([]);
  const [inwardShipmentMonthlyCount, setInwardShipmentMonthlyCount] = useState<any>([]);
const [todaysinwardLog, setTodaysInwardLogcount] = useState(0)
const [todaysinwardDetail, setTodaysInwardDetail] = useState(0)
const [todaysinwardDetailPending, setTodaysInwardDetailPending] = useState(0)
const [todaysinwardDetailDeliverded, setTodaysInwardDetailDelivered] = useState(0)
const [todaysinwardDetailRedirect, setTodaysInwardDetailRedirect] = useState(0)

  const [months, setMonths] = useState<any>([]);
  const handleSelectChange = (selectedOption: any) => {
    if (selectedOption) {
      const [month, year] = selectedOption.value.split('/');
      setSelectedMonth(month);
      setSelectedYear(year);
    }
  };
  useEffect( () => {
    const monthsData: any = [];
    for (let i = 0; i < 12; i++) {
      const month = moment().clone().subtract(i, 'months');
      const monthLabel = month.format('MMMM');
      const yearLabel = month.format('YYYY');
      const value = month.format('MM/YYYY');
      monthsData.push({ label: `${monthLabel} ${yearLabel}`, value });    
    }
    setMonths(monthsData);
    getDateWiseInwardShipment();  
    getinwardStatusForBarChart();
    inwardshipmentofmonth();
    inwardshipmentmonthlycount();
  }, []);
  
  useEffect(()=>{       
    getinwardStatusForBarChart();
    getDateWiseInwardShipment();
    inwardshipmentofmonth();
    const dts = selectedYear + '-'+selectedMonth+'-01'
    const ldate = moment(dts).endOf('month').format("DD");
      setLastDate(parseInt(ldate))     
  },[selectedMonth])


  


  // ------  DatwWise Shipment -------
  const getDateWiseInwardShipment = async () => {
   await DashboardDataService.getDateWiseInwardShipment(selectedMonth, selectedYear).then(
      async (data) => {
      await setdateWiseData(data)
      }).catch((error) => {
      console.log(error);
      // console.log("server Responding");
    })
  }

  const getinwardStatusForBarChart = async () => {
    await DashboardDataService.getinwardstatusofmonth(selectedMonth, selectedYear).then(
      async (data) => {
        if(data !==""){
          const options = data.map((d: any) => ({
            "value": d.count,
            "name": d.description
        }))
        await setdataforBarChart(options)
        }else {
          const data1 :any = [
            { name: "Loading....", value: 1 },       
          ];
          await setdataforBarChart(data1)
        }
      }

    ).catch((error) => {
      console.log(error);
      console.log("server Responding");
    }) 
  }
  const inwardshipmentofmonth = async () => {
    await DashboardDataService.inwardshipmentofmonth(selectedMonth, selectedYear).then(
      async (data) => {       
          await setInwardShipmentofMonth(data);
          await setTodaysInwardDetail(data[0].todaysinwardEntry);
          await setTodaysInwardDetailDelivered(data[0].todaysinwardEntryDelivered);
          await setTodaysInwardDetailPending(data[0].todaysinwardEntryPending);
          await setTodaysInwardDetailRedirect(data[0].todaysinwardEntryRedirect);
          await setTodaysInwardLogcount(data[0].todaysinwardLog);  
        }

    ).catch((error) => {
      console.log(error);
    }) 
  }
  const inwardshipmentmonthlycount = async () => {
    await DashboardDataService.inwardshipmentmonthlycount().then(
      async (data) => {     
        setInwardShipmentMonthlyCount(data)
      }
    ).catch((error) => {
      console.log(error);
    }) 
  }
  const data = [{ name: 'Log vs Inward', value: todaysinwardLog, color: '#db1c29' }]; 
  const data1 = [{ name: 'At Mailroom Desk', value: todaysinwardDetail, color: '#f9f324' }]; 
  const data2 = [{ name: 'Deliverd', value: todaysinwardDetail, color: '#4fce14' }]; 
  const data3 = [{ name: 'Redirect', value: todaysinwardDetail, color: '#0f6af5' }]; 
  const cx = 140; // X-coordinate of the pie chart's center
const cy = 160; // Y-coordinate of the pie chart's center
const iR = 60; // Inner radius of the pie chart
const oR = 100; // Outer radius of the pie chart
const value = 50; // The value to point at

  return (
    <div className='overflow'>
      <DashboardHeader selectedMonth={selectedMonth} selectedYear ={selectedYear} months={months} handleSelectChange={handleSelectChange}/>
       <div style={{ margin: "0px" }}>
        <div style={{ display: "flex", flexDirection: "column", paddingTop: "1%" }}>          
          <div className="container col-11" style={{ paddingLeft: "0px" }}>
      <div className="themeColor" style={{ width: '100%'}} ><p style={{ marginLeft: "10px" }}> Inbound Dashboard </p></div>
      <div className='width dash-main'>
      <DatewiseTable selectedMonth={selectedMonth} selectedYear ={selectedYear} dateWiseData={dateWiseData} lastDate = {lastDate}/>



      <div className='col-12 row'>
        <div className='col-3'>
        <Logvsentry data={data} cx={cx} cy={cy} iR={iR} oR={oR} value={todaysinwardDetail}/>
        </div> 
        <div className='col-3'>
        <Logvsentry data={data1} cx={cx} cy={cy} iR={iR} oR={oR} value={todaysinwardDetailPending}/>
        </div> 
        <div className='col-3'>
        <Logvsentry data={data2} cx={cx} cy={cy} iR={iR} oR={oR} value={todaysinwardDetailDeliverded}/>
        </div> 
        <div className='col-3'>
        <Logvsentry data={data3} cx={cx} cy={cy} iR={iR} oR={oR} value={todaysinwardDetailRedirect}/>
        </div> 
      </div>

      <div className='col-12 inline' style={{marginRight :'0px'}}>
        <div className='col-9 bartable' style={{borderRight : '1px solid #ccc'}}>
         
      <MonthWiseShipmentTable   countData={inwardShipmentMonthlyCount} />
      
      <InwardStatusBarChart  dataforBarChart ={dataforBarChart} todaysDate={todaysDate} />
        </div>
        <div className='col-3 paichart'>
          <Charts selectedMonth={selectedMonth} selectedYear ={selectedYear} inwardShipmentofMonth={inwardShipmentofMonth}/>
        </div>
      </div>
      
      </div>
      {/* <div>
        <MonthInboundTable />
      </div> */}
    </div>
    </div>
    </div>
    </div>
  )
}

export default InwardDashboard